export const IFrameType = {
  Accommodations: 'Accommodations',
  Equipments: 'Equipments'
};
